import React from 'react';
import {
    StyledResources,
} from './styled'




const Resources = (props) => {
    const {resourcesList} = props


    // if there is no any pros, don't display the jumbotron
    if (! resourcesList) {
        return null
    }


    const resources = resourcesList.map(resource => {
        const {icon, title, source} = resource

        return (
            <a key={"Resource-" + title.replace(/\s/g, '')} download href={source}>
                {icon}
                {title}
            </a>
        )
    })

    return (
        <StyledResources>
            <h2>Resources</h2>
            {resources}
        </StyledResources>
    )
}

export default Resources;
